module.exports = __webpack_public_path__ + "static/media/bravo.869bf62d.svg";